/**
 * Mini Cart Drawer Engine - Vastradevi Theme
 * AJAX-driven slide-in cart, backed by Shopify's /cart.js, /cart/add.js, /cart/change.js
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents);
    }
    var amount = (cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    return '₹' + amount;
  }

  function escapeHTML(str) {
    return String(str).replace(/[&<>'"]/g,
      function (tag) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[tag] || tag; }
    );
  }

  // Same "charm pricing" fallback used on the product page and Quick View
  // (see snippets/round-price-charm.liquid, assets/quickview.js) - when a
  // variant has no real compare_at_price, show a computed price * 1.5 "was"
  // price rounded to a charming ...9 whole rupee.
  function roundToCharm9(rupees) {
    rupees = Math.round(rupees);
    var lower9 = Math.floor((rupees - 9) / 10) * 10 + 9;
    var upper9 = lower9 + 10;
    var result = (rupees - lower9 <= upper9 - rupees) ? lower9 : upper9;
    return Math.max(9, result);
  }

  // cart.js line items don't expose compare_at_price, so real markdown
  // prices are fetched once per product handle and cached here (keyed by
  // variant_id -> compare_at_price in cents).
  var compareAtCache = {};

  function ensureCompareAtPrices(cart) {
    var handles = [];
    cart.items.forEach(function (item) {
      if (!compareAtCache[item.handle] && handles.indexOf(item.handle) === -1) {
        handles.push(item.handle);
      }
    });
    if (!handles.length) return Promise.resolve();

    return Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (res) { return res.ok ? res.json() : null; })
        .then(function (product) {
          if (!product) return;
          var map = {};
          (product.variants || []).forEach(function (v) {
            map[v.id] = (v.compare_at_price && v.compare_at_price > v.price) ? v.compare_at_price : null;
          });
          compareAtCache[handle] = map;
        })
        .catch(function () { compareAtCache[handle] = {}; });
    }));
  }

  function getCompareAtLinePrice(item) {
    var perUnit = (compareAtCache[item.handle] && compareAtCache[item.handle][item.variant_id]) || null;
    if (!perUnit) {
      perUnit = roundToCharm9((item.price / 100) * 1.5) * 100;
    }
    return perUnit * item.quantity;
  }

  function getElements() {
    return {
      drawer: document.getElementById('CartDrawer'),
      backdrop: document.getElementById('CartDrawerBackdrop'),
      loadingOverlay: document.getElementById('CartDrawerLoadingOverlay'),
      closeBtn: document.getElementById('CartDrawerClose'),
      body: document.getElementById('CartDrawerBody'),
      countEl: document.getElementById('CartDrawerCount'),
      subtotalEl: document.getElementById('CartDrawerSubtotal'),
      footer: document.getElementById('CartDrawerFooter'),
      discountInput: document.getElementById('CartDrawerDiscountInput'),
      discountApplyBtn: document.getElementById('CartDrawerDiscountApply'),
      discountMsg: document.getElementById('CartDrawerDiscountMsg'),
      discounts: document.getElementById('CartDrawerDiscounts'),
      discountToggle: document.getElementById('CartDrawerDiscountToggle'),
      discountBody: document.getElementById('CartDrawerDiscountBody'),
      noteToggle: document.getElementById('CartDrawerNoteToggle'),
      noteBody: document.getElementById('CartDrawerNoteBody'),
      noteInput: document.getElementById('CartDrawerNoteInput'),
      noteSaveBtn: document.getElementById('CartDrawerNoteSaveBtn'),
      noteMsg: document.getElementById('CartDrawerNoteMsg')
    };
  }

  function open() {
    var els = getElements();
    if (!els.drawer) return;
    els.drawer.classList.add('is-open');
    els.drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }

  function close() {
    var els = getElements();
    if (!els.drawer) return;
    els.drawer.classList.remove('is-open');
    els.drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    hideLoadingOverlay();
  }

  function showLoadingOverlay() {
    var overlay = getElements().loadingOverlay;
    if (overlay) overlay.hidden = false;
  }

  function hideLoadingOverlay() {
    var overlay = getElements().loadingOverlay;
    if (overlay) overlay.hidden = true;
  }

  function renderItem(item) {
    var variantHtml = '';
    if (item.variant_title && item.product_has_only_default_variant === false) {
      variantHtml = '<span class="cart-drawer__item-variant">' + escapeHTML(item.variant_title) + '</span>';
    }

    var compareLinePrice = getCompareAtLinePrice(item);
    var savings = compareLinePrice - item.final_line_price;
    var priceColHtml =
      '<div class="cart-drawer__item-price-col">' +
        (savings > 0
          ? '<span class="cart-drawer__item-price-compare" data-money="' + compareLinePrice + '">' + formatMoney(compareLinePrice) + '</span>'
          : '') +
        '<div class="cart-drawer__item-price" data-money="' + item.final_line_price + '">' + formatMoney(item.final_line_price) + '</div>' +
        (savings > 0
          ? '<span class="cart-drawer__item-save" data-money="' + savings + '">You save ' + formatMoney(savings) + '</span>'
          : '') +
      '</div>';

    return (
      '<li class="cart-drawer__item" data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="cart-drawer__item-image">' +
          '<img src="' + (item.image || '') + '" alt="' + escapeHTML(item.product_title) + '" width="80" height="100" loading="lazy">' +
        '</a>' +
        '<div class="cart-drawer__item-details">' +
          '<a href="' + item.url + '" class="cart-drawer__item-title">' + escapeHTML(item.product_title) + '</a>' +
          variantHtml +
          '<div class="cart-drawer__item-qty-row">' +
            '<div class="cart-drawer__qty-selector">' +
              '<button type="button" class="cart-drawer__qty-btn" data-cart-qty-minus data-key="' + item.key + '" aria-label="Decrease quantity">&minus;</button>' +
              '<span class="cart-drawer__qty-value">' + item.quantity + '</span>' +
              '<button type="button" class="cart-drawer__qty-btn" data-cart-qty-plus data-key="' + item.key + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
            '<button type="button" class="cart-drawer__remove" data-cart-remove data-key="' + item.key + '" aria-label="Remove item">Remove</button>' +
          '</div>' +
        '</div>' +
        priceColHtml +
      '</li>'
    );
  }

  function render(cart) {
    var els = getElements();
    if (!els.body) return;

    document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = cart.item_count; });
    if (els.countEl) els.countEl.textContent = '(' + cart.item_count + ')';

    if (cart.item_count === 0) {
      els.body.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">' +
            '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path>' +
            '<line x1="3" y1="6" x2="21" y2="6"></line>' +
            '<path d="M16 10a4 4 0 0 1-8 0"></path>' +
          '</svg>' +
          '<p>Your cart is empty</p>' +
          '<a href="/collections/all" class="btn-primary">Start Shopping</a>' +
        '</div>';
      if (els.footer) els.footer.style.display = 'none';
      return;
    }

    renderItems(cart);
    if (els.footer) els.footer.style.display = '';
    if (els.subtotalEl) { els.subtotalEl.textContent = formatMoney(cart.total_price); els.subtotalEl.setAttribute('data-money', cart.total_price); }

    renderDiscounts(cart);

    // Items render immediately using whatever compare-at data is already
    // cached (falling back to the charm-pricing estimate); once the real
    // compare_at_price for each product loads, re-render in place so the
    // savings figures self-correct without blocking the drawer opening.
    ensureCompareAtPrices(cart).then(function () {
      renderItems(cart);
      bindItemEvents();
    });

    bindItemEvents();
  }

  function renderItems(cart) {
    var els = getElements();
    if (!els.body) return;

    els.body.innerHTML = '<ul class="cart-drawer__items">' + cart.items.map(renderItem).join('') + '</ul>';

    var totalSavings = cart.items.reduce(function (sum, item) {
      return sum + Math.max(0, getCompareAtLinePrice(item) - item.final_line_price);
    }, 0);
    var savingsRow = document.getElementById('CartDrawerSavingsRow');
    var savingsEl = document.getElementById('CartDrawerSavings');
    if (savingsRow && savingsEl) {
      if (totalSavings > 0) {
        savingsEl.textContent = formatMoney(totalSavings);
        savingsEl.setAttribute('data-money', totalSavings);
        savingsRow.style.display = '';
      } else {
        savingsRow.style.display = 'none';
      }
    }
  }

  // Builds the list of applied discounts to display. The entered coupon code
  // lives in cart.discount_codes (has `.code`); its saved amount lives in
  // cart_level_discount_applications (has `.title` + `.total_allocated_amount`).
  // We prefer the actual code and match it to its amount so nothing shows as
  // "undefined".
  //
  // /cart.js returns cart_level_discount_applications flat ({title,
  // total_allocated_amount, ...}), but /cart/change.js nests the same data
  // under a `discount_application` key ({amount, discount_application:
  // {title, total_allocated_amount, ...}}). Normalize both so the discount
  // still shows correctly right after a quantity change.
  function normalizeDiscountApp(a) {
    var d = a.discount_application || a;
    var amount = typeof d.total_allocated_amount === 'number' ? d.total_allocated_amount : a.amount;
    return { title: d.title, amount: amount || 0 };
  }

  function collectDiscounts(cart) {
    var apps = (cart.cart_level_discount_applications || []).map(normalizeDiscountApp);
    var codes = (cart.discount_codes || []).filter(function (c) { return c.applicable && c.code; });
    var items = [];

    if (codes.length) {
      codes.forEach(function (c) {
        var match = apps.filter(function (a) {
          return a.title && a.title.toUpperCase() === c.code.toUpperCase();
        })[0];
        items.push({ label: c.code, amount: match ? match.amount : 0 });
      });
    } else {
      // No code (automatic discount): fall back to the application titles
      apps.forEach(function (a) {
        if (!a.title) return;
        items.push({ label: a.title, amount: a.amount });
      });
    }
    // hasCode: true only when the customer entered a coupon code - automatic
    // discounts aren't removable, so the Remove link must stay hidden for them.
    return { items: items, hasCode: codes.length > 0 };
  }

  function renderDiscounts(cart) {
    var els = getElements();
    if (!els.discounts) return;

    var result = collectDiscounts(cart);
    var items = result.items;
    if (!items.length) {
      els.discounts.style.display = 'none';
      els.discounts.innerHTML = '';
      return;
    }

    var codeIcon =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
        '<path d="M2 9a3 3 0 1 0 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 1 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2z"></path>' +
        '<line x1="13" y1="5" x2="13" y2="7"></line>' +
        '<line x1="13" y1="11" x2="13" y2="13"></line>' +
        '<line x1="13" y1="17" x2="13" y2="19"></line>' +
      '</svg>';

    var heading = items.length + ' discount' + (items.length === 1 ? '' : 's') + ' applied';

    var lines = items.map(function (d) {
      var amount = d.amount ? '<span class="cart-drawer__discount-amount" data-money-prefix="−" data-money="' + d.amount + '">−' + formatMoney(d.amount) + '</span>' : '';
      return (
        '<div class="cart-drawer__discount-line">' +
          '<span class="cart-drawer__discount-code">' + codeIcon + escapeHTML(d.label) + '</span>' +
          amount +
        '</div>'
      );
    }).join('');

    var removeLink = result.hasCode
      ? '<button type="button" class="cart-drawer__discount-remove" data-discount-remove>Remove</button>'
      : '';

    els.discounts.innerHTML =
      '<p class="cart-drawer__discounts-heading">' +
        '<span>' + heading + '</span>' +
        removeLink +
      '</p>' + lines;
    els.discounts.style.display = '';
  }

  function refresh() {
    return fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) { render(cart); return cart; })
      .catch(function () {});
  }

  function changeItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) { render(cart); return cart; })
      .catch(function () {});
  }

  function bindItemEvents() {
    document.querySelectorAll('#CartDrawerBody [data-cart-qty-minus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var valueEl = btn.parentElement.querySelector('.cart-drawer__qty-value');
        var current = parseInt(valueEl.textContent, 10) || 1;
        changeItem(key, Math.max(0, current - 1));
      });
    });
    document.querySelectorAll('#CartDrawerBody [data-cart-qty-plus]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-key');
        var valueEl = btn.parentElement.querySelector('.cart-drawer__qty-value');
        var current = parseInt(valueEl.textContent, 10) || 1;
        changeItem(key, current + 1);
      });
    });
    document.querySelectorAll('#CartDrawerBody [data-cart-remove]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        changeItem(btn.getAttribute('data-key'), 0);
      });
    });
  }

  // POSTing a `discount` to /cart/update.js applies (or clears, with an
  // empty string) a cart-level discount code entirely over AJAX - no page
  // navigation needed, unlike the old /discount/<code> redirect trick this
  // replaced (kept full-page reloads in the loop for no reason and, for
  // removal, didn't even reliably work).
  function applyDiscount(rawCode) {
    var els = getElements();
    var code = (rawCode || '').trim();
    if (!code) {
      if (els.discountInput) els.discountInput.focus();
      return;
    }
    var btn = els.discountApplyBtn;
    if (btn) {
      btn.disabled = true;
      btn.textContent = '...';
    }
    showLoadingOverlay();
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ discount: code })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        render(cart);
        hideLoadingOverlay();
        var applied = (cart.discount_codes || []).some(function (c) {
          return c.applicable && c.code && c.code.toUpperCase() === code.toUpperCase();
        });
        if (els.discountMsg) {
          els.discountMsg.textContent = applied
            ? 'Code "' + code + '" applied.'
            : 'Code "' + code + '" is invalid, expired, or doesn\'t apply to your cart.';
          els.discountMsg.classList.toggle('cart-drawer__discount-msg--success', applied);
          els.discountMsg.classList.toggle('cart-drawer__discount-msg--error', !applied);
          els.discountMsg.style.display = '';
        }
      })
      .catch(function () { hideLoadingOverlay(); })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = 'APPLY'; }
      });
  }

  function addItem(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (err) { throw err; });
        return res.json();
      })
      .then(function (added) {
        return refresh().then(function () { return added; });
      });
  }

  function initListeners() {
    var els = getElements();
    if (!els.drawer) return;

    if (els.closeBtn) els.closeBtn.addEventListener('click', close);
    if (els.backdrop) els.backdrop.addEventListener('click', close);

    document.addEventListener('keydown', function (evt) {
      if (evt.key === 'Escape') close();
    });

    // Open the drawer for cart links across the site, but NOT the drawer's own
    // "View Cart" link - that one must navigate through to the /cart page.
    document.querySelectorAll('a[href="/cart"]').forEach(function (link) {
      if (link.classList.contains('cart-drawer__view-cart-link')) return;
      link.addEventListener('click', function (evt) {
        evt.preventDefault();
        refresh().then(open);
      });
    });

    // "Add to Cart" on collection/search/wishlist product cards - adds the
    // card's first available variant directly, no size/colour picker. Bound
    // via delegation since these buttons live in cards rendered all over the
    // site (and, for infinite-scroll grids, ones that don't exist yet).
    document.addEventListener('click', function (evt) {
      var btn = evt.target.closest && evt.target.closest('[data-quick-add-variant-id]');
      if (!btn || btn.disabled) return;
      var variantId = btn.getAttribute('data-quick-add-variant-id');
      if (!variantId) return;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'ADDING...';
      addItem(variantId, 1)
        .then(function () {
          btn.textContent = 'ADDED';
          open();
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        })
        .catch(function () {
          btn.textContent = 'ERROR';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        });
    });

    if (els.discountApplyBtn && els.discountInput) {
      els.discountApplyBtn.addEventListener('click', function () {
        applyDiscount(els.discountInput.value.trim());
      });
      els.discountInput.addEventListener('keydown', function (evt) {
        if (evt.key === 'Enter') {
          evt.preventDefault();
          applyDiscount(els.discountInput.value.trim());
        }
      });
    }

    // Discount "Remove" button is re-rendered on every renderDiscounts() call,
    // so bind via delegation once instead of re-binding after each render.
    // /discount/none (the old full-page redirect trick) does NOT reliably
    // clear a cart-level discount code on this store - the code stays
    // applied even after the redirect. POSTing an empty `discount` to
    // /cart/update.js is the AJAX Cart API's actual removal mechanism and
    // updates the cart immediately, no reload needed.
    document.addEventListener('click', function (evt) {
      var btn = evt.target.closest && evt.target.closest('[data-discount-remove]');
      if (!btn) return;
      btn.disabled = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ discount: '' })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) { render(cart); })
        .catch(function () {});
    });

    // ── Discount panel: collapsed by default, opened via its icon button ──
    if (els.discountToggle && els.discountBody) {
      els.discountToggle.addEventListener('click', function () {
        var opening = els.discountBody.hasAttribute('hidden');
        if (opening) { els.discountBody.removeAttribute('hidden'); } else { els.discountBody.setAttribute('hidden', ''); }
        els.discountToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
        if (opening && els.discountInput) els.discountInput.focus();
      });
    }

    // ── Order note: collapsed by default (server-rendered `hidden` reflects
    // whether cart.note is blank); toggle just flips that state client-side.
    if (els.noteToggle && els.noteBody && els.noteInput && els.noteSaveBtn) {
      els.noteToggle.addEventListener('click', function () {
        var opening = els.noteBody.hasAttribute('hidden');
        if (opening) { els.noteBody.removeAttribute('hidden'); } else { els.noteBody.setAttribute('hidden', ''); }
        els.noteToggle.setAttribute('aria-expanded', opening ? 'true' : 'false');
        if (opening) els.noteInput.focus();
      });

      els.noteSaveBtn.addEventListener('click', function () {
        els.noteSaveBtn.disabled = true;
        els.noteSaveBtn.textContent = 'SAVING...';
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ note: els.noteInput.value })
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            if (els.noteMsg) {
              els.noteMsg.textContent = 'Note saved.';
              els.noteMsg.style.display = '';
            }
          })
          .catch(function () {
            if (els.noteMsg) {
              els.noteMsg.textContent = 'Could not save note - please try again.';
              els.noteMsg.style.display = '';
            }
          })
          .finally(function () {
            els.noteSaveBtn.disabled = false;
            els.noteSaveBtn.textContent = 'SAVE NOTE';
          });
      });
    }

    bindItemEvents();
  }

  // The server-rendered discount panel (and its Remove link) is built from
  // cart.discount_codes in Liquid, which has been observed to render empty
  // even when a code is genuinely applied and /cart.js correctly reports it
  // - leaving a real discount with no way to remove it. Re-render the panel
  // from the AJAX cart on every load so it reflects the reliable source.
  function refreshDiscountPanel() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) { renderDiscounts(cart); })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initListeners();
      refreshDiscountPanel();
    });
  } else {
    initListeners();
    refreshDiscountPanel();
  }

  window.VDCartDrawer = {
    open: function () { refresh().then(open); },
    close: close,
    refresh: refresh,
    addItem: addItem
  };
})();
